/**
 * 在组件内通过commit调用mutations的方法改变store的状态，同时各组件都会跟着变化
 */

import * as types from './mutation-types.js';

export default {
  [types.SHOW_DIALOG] (state, status) {
    state.showDialog = status;
  },
  [types.USER_INFO] (state, status) {
    state.userInfo = status;
  },
  [types.DEVICE_INFO] (state, status) {
    state.deviceInfo = status;
  },
  [types.LOADING] (state, status) {
    state.loading = status;
  },
  [types.CHILDREN] (state, status) {
    state.children = status;
  },
  [types.CHILDID] (state, status) {
    localStorage.setItem('childId', status)
    state.childId = status;
  },
  [types.isWxConfigRegister] (state, status) {
    state.isWxConfigRegister = status;
  },
};
